<template>
  <div v-if="showBanner" :class="['happiness-guarantee-banner font-small', { 'in-app': inApp }]">
    <div class="banner-content">
      <span class="pr-1">❤️</span>
      {{ content.banner }}
      <a class="font-bold learn-more-link" @click="showHappinessGuarantee"> Learn more > </a>
    </div>
    <span aria-role="button" class="dismiss-banner font-weight-bold font-xl" @click="dismissBanner">
      x
    </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import content from '@/content/promotions/bungalowGuarantee.js'
import HappinessGuaranteeModal from '../Modals/Listings/HappinessGuaranteeModal.vue'

export default {
  name: 'HappinessGuarantee',
  data() {
    return {
      content,
    }
  },
  computed: {
    ...mapGetters('notifications', ['showBanner']),
    inApp() {
      return this.$route.query.is_app
    },
  },
  methods: {
    ...mapActions('notifications', ['dismissBanner']),
    showHappinessGuarantee() {
      this.$root.$emit('openModal', { modalComponent: HappinessGuaranteeModal })
    },
  },
}
</script>

<style lang="scss">
.happiness-guarantee-banner {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $blue-10;
  color: $blue-80;
  text-align: center;
  min-height: 60px;

  .learn-more-link {
    cursor: pointer;
    margin-left: 5px;
    color: $blue-80 !important;
    white-space: nowrap;
  }

  .banner-content {
    font-size: 16px;

    @include mobile {
      font-size: 14px;
      max-width: 300px;
      margin-right: 1.5rem;
    }
  }

  .dismiss-banner {
    transition: border 0.15s ease;
    cursor: pointer;
    position: absolute;
    right: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    border-radius: 100%;
    width: 24px;
    height: 24px;

    @include mobile {
      right: 0.5rem;
      top: 0.75rem;
    }

    &:hover,
    &:active {
      border-color: $blue-80;
    }
  }

  @include mobile {
    padding-top: 0.35rem;
    // padding-top: 0.75rem;
  }
}
</style>
